/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';

export const useCountdown = (time) => {
    const [seconds, setSeconds] = useState(time);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setSeconds(prev => prev > 0 ? prev - 1 : prev);
        }, 1000);

        return () => clearTimeout(timeoutId)
    }, [seconds]);

    return {seconds, setSeconds};
}